<script>
    import { ButtonGroup, Button } from "@sveltestrap/sveltestrap";
    import { createEventDispatcher } from "svelte";
    export let showModal; // boolean
    export let joueurs;

    const dispatch = createEventDispatcher();

    let dialog; // HTMLDialogElement

    $: if (dialog && showModal) dialog.showModal();

    function pickJoueur(j) {
        // console.log('pick modal')
        // console.log(j)
        showModal = false;
        dispatch("joueurChosen", j);
        dialog.close();
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-noninteractive-element-interactions -->
<dialog
    bind:this={dialog}
    on:close={() => (showModal = false)}
    on:click|self={() => dialog.close()}
>
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div on:click|stopPropagation>
        <h2>Recherche joueur</h2>

        <ButtonGroup vertical>
            {#each joueurs as j}
                <Button style="text-align:left" on:click={(e) => pickJoueur(j)}
                    >{j[1]} - {j[0]}</Button
                >
            {/each}
        </ButtonGroup>
        <div class="center" style="padding:12px">
            <button on:click={() => dialog.close()}
                >Fermer &nbsp;
                <i class="bi bi-x"></i>&nbsp;
            </button>
        </div>
    </div>
</dialog>

<style>
    .center {
        text-align: center;
        display: flex;
        /* //flex-flow: column; */
        justify-content: center;
    }
    dialog {
        max-width: 32em;
        border-radius: 0.2em;
        border: none;
        padding: 0;
    }
    dialog::backdrop {
        background: rgba(0, 0, 0, 0.3);
    }
    dialog > div {
        padding: 1em;
    }
    dialog[open] {
        animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
    @keyframes zoom {
        from {
            transform: scale(0.95);
        }
        to {
            transform: scale(1);
        }
    }
    dialog[open]::backdrop {
        animation: fade 0.2s ease-out;
    }
    @keyframes fade {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    button {
        display: block;
    }
</style>
